import state from './moduleSOSState.js'
import mutations from './moduleSOSMutations.js'
import actions from './moduleSOSActions.js'
import getters from './moduleSOSGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
